import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button/Button';
import PaxButton from './PaxButton';
import PaxToolBox from './PaxToolBox';
import classnames from 'classnames';
import css from './styles.less';

const checkRtl = (direction = '') => direction.toLowerCase() === 'right';


class PaxPart extends React.Component {

    renderSingleLineVersion = (paxRow, idx) => {
        const {
            maxNumOfRooms,
            pax,
            direction,
            titles,
            onClickAddRoom,
            onClickRemoveRoom,
            onPaxAction,
            isRootElementMobileView
        } = this.props
        const isLastRow = idx === pax.length - 1;
        const isSingle = pax.length === 1;
        const isLessThanMaxRoomsAllowed = maxNumOfRooms > idx + 1;
        const shouldRenderRemoveBtn = !isSingle;
        const shouldRenderAddBtn = (isSingle || isLastRow) && isLessThanMaxRoomsAllowed;
        const shouldRTL = checkRtl(direction);
        return (
            <div key={idx} className={`${css.singleLinePax} ${shouldRTL && css.rtl} ${isRootElementMobileView && css.compactRootElement} sbox-container-fluid`}>
                <div className={css.roomTitleWrapper + " sbox-col-lg-4 sbox-col-md-4 sbox-col-sm-12 sbox-col-xs-12"}>
                    <PaxButton
                        type={PaxButton.types.remove}
                        onClick={() => onClickRemoveRoom(idx + 1)}
                        className={`${css.btn} ${css.removeRoomBtn} ${!shouldRenderRemoveBtn && css.hidden}`}
                    />
                    <div className={css.roomNumberTitle}>{`${titles.Room} ${idx + 1}`}</div>

                </div>

                <div className={`${css.toolboxWrapper} ${shouldRTL && css.rtl} sbox-col-md-8 sbox-col-sm-12 sbox-col-xs-12`}>
                    <PaxToolBox
                        {...this.props}
                        activeRoomNum={idx}
                        pax={pax[idx]}
                        onPaxAction={onPaxAction}
                    />
                </div>
                <div className={css.addRoomBtnWrapper + " sbox-col-md-2 sbox-hidden-xs sbox-hidden-sm"}>
                    {
                        <PaxButton
                            type={PaxButton.types.plus}
                            onClick={onClickAddRoom}
                            className={`${css.btn} ${css.addRoomBtn} ${!shouldRenderAddBtn && css.hidden}`}
                        >
                            {this.maybeTitle(titles.AddRoom)}
                        </PaxButton>
                    }
                </div>
            </div>

        );
    }

    renderDoubleLinesVersion = (paxRow, idx) => {
        const {
            maxNumOfRooms,
            pax,
            direction,
            titles,
            activeRoomNum,
            onClickAddRoom,
            onClickRemoveRoom,
            changeActiveRoomNumber,
            onPaxAction,
            isRootElementMobileView
        } = this.props
        const isLastRow = idx === pax.length - 1;
        const isSingle = pax.length === 1;
        const isLessThanMaxRoomsAllowed = maxNumOfRooms > idx + 1;
        const shouldRenderRemoveBtn = !isSingle;
        //const shouldRenderAddBtn = (isSingle || isLastRow) && isLessThanMaxRoomsAllowed;
        const shouldRTL = checkRtl(direction);
        return (
            <div key={idx} className={`${css.singleLinePax} ${shouldRTL && css.rtl} ${isRootElementMobileView && css.compactRootElement} sbox-container-fluid`}>
                <div className={css.roomTitleWrapper + " sbox-col-lg-12"}>
                    <PaxButton
                        type={PaxButton.types.remove}
                        onClick={() => onClickRemoveRoom(idx + 1)}
                        className={`${css.btn} ${css.removeRoomBtn} ${!shouldRenderRemoveBtn && css.hidden}`}
                    />
                    <div className={css.roomNumberTitle}>{`${titles.Room} ${idx + 1}`}</div>
                </div>
                <div className={`${css.toolboxWrapper} ${shouldRTL && css.rtl} sbox-col-lg-12`}>
                    <PaxToolBox
                        {...this.props}
                        activeRoomNum={idx}
                        pax={pax[idx]}
                        onPaxAction={onPaxAction}
                    />
                </div>
            </div>

        );
    }

    maybeTitle = (title) => {
        return title && <div>{title}</div>
    }

    render() {

        const {
            maxNumOfRooms,
            pax,
            direction,
            titles,
            onClickSendSubmitSearchBox,
            enableSubmit,
            onClickAddRoom
        } = this.props;
        const shouldRTL = checkRtl(direction);
        return (
            <div className={classnames(css.paxPartHolder, css[direction])}>
                <div className={`${css.roomsWrapper} ${shouldRTL && css.rtl} sbox-col-md-9 sbox-col-sm-12 sbox-col-xs-12`}>
                    <div className={classnames(css.rooms)}>
                        {
                            pax.map((paxRow, idx) => {
                                return this.renderSingleLineVersion(paxRow, idx);
                            })
                        }
                    </div>

                </div>
                {
                    maxNumOfRooms > pax.length && (
                        <div className={`${css.addRoomBtnWrapper} sbox-hidden-lg sbox-hidden-md`}>
                            <PaxButton
                                type={PaxButton.types.plus}
                                onClick={onClickAddRoom}
                                className={`${css.btn} ${css.addRoomBtn}`}
                            >
                                {this.maybeTitle(titles.AddRoom)}
                            </PaxButton>
                        </div>
                    )
                }

                <div className={css.searchButton + " sbox-col-md-3 sbox-col-xs-12 sbox-col-sm-12"}>
                    <Button
                        {...this.props}
                        text={titles && titles.SearchButtonText}
                        isShadow={false}
                        onClickHandler={onClickSendSubmitSearchBox}
                        id='searchButton'
                        disable={!enableSubmit}
                    />
                </div>
            </div>
        );
    }
};

PaxPart.propTypes = {
    isRootElementMobileView: PropTypes.bool,
    maxNumOfRooms: PropTypes.number,
    pax: PropTypes.array,
    activeRoomNum: PropTypes.number,
    isRounded: PropTypes.bool,
    titles: PropTypes.object,
    config: PropTypes.object,
    regionHotel: PropTypes.object,
    onChangePax: PropTypes.func,
    onClickRemoveRoom: PropTypes.func,
    onClickAddRoom: PropTypes.func,
    onClickSendSubmitSearchBox: PropTypes.func,
    onSubmitWithRegionHotel: PropTypes.func,
    onPaxAction: PropTypes.func,
}

PaxPart.defaultProps = {
    maxNumOfRooms: 3
};

export default PaxPart;




// WEBPACK FOOTER //
// ./src/components/PaxPart/PaxPart.js